module.exports = __webpack_public_path__ + "img/GroupBack.51d2ce40.png";